/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUserVaccinationScheduleDetails } from 'app/shared/model/user-vaccination-schedule-details.model';
import { IPregnancyCase } from 'app/shared/model/pregnancy-case.model';
import { ITrimester } from 'app/shared/model/trimester.model';

export interface IPregnancyVaccine {
  id?: string;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  vaccine?: IUserVaccinationScheduleDetails | null;
  pregnancy?: IPregnancyCase | null;
  trimester?: ITrimester | null;
}

export const defaultValue: Readonly<IPregnancyVaccine> = {
  active: false,
  draft: false,
};
